<template>
    <div class="container-fluid">
        <div class="row">
            <FormReceiptDetail  v-model:receiptDetail="formReceiptDetail"/>
            <FormProductDetail :checklist="checklistData" v-model:productDetail="formProductDetail"/>
            <FormCheckList :checklist="checklistData" @update:checklist="updateChecklist" v-if="!disabledField" />
            <!-- <FormReceiptHistory colClass="col-12" headerTitle="true" titles="true" title="ประวัติ"/> -->
        </div>
        <div class="col-xl-12">
            <div class="d-flex gap-2 pull-right mb-4">
                <button class="btn btn-success pull-right" type="button" @click="submitForm" :disabled="formReceiptDetail.status === 'ผ่าน'">บันทึก</button>
                <button class="btn btn-danger pull-right" type="button" @click="deleteForm" :disabled="formReceiptDetail.status === 'ผ่าน'">ลบ</button>
            </div>
        </div>

    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { useRoute , useRouter} from 'vue-router';
import { directus } from "@/services/directus";
import { updateItem , deleteItem , readItems} from "@directus/sdk";
import Swal from 'sweetalert2'

const FormReceiptDetail = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormReceiptDetail.vue"))
const FormProductDetail = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormProductDetail.vue"))
const FormCheckList = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormCheckList.vue"))
const FormReceiptHistory = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormReceiptHistory.vue"))

const formProductDetail = ref([]);
const formReceiptDetail = ref([]);

const route = useRoute();
const router = useRouter();
const disabledField = ref(false);

const checklistData = ref([]);
    const updateChecklist = (newChecklist) => {
    checklistData.value = newChecklist;
    disabledField.value = checklistData.value.length === 0;
};

const submitForm = () => {
    updatePorducts()
};

async function deleteForm() {
    const confirmDeleteResult = await questionsAlert()
    
    if (!confirmDeleteResult.isConfirmed) return;
    
    await directus.request(
      deleteItem("stock", route.params.id)
    );
    deleteAlert()
    router.push({ name: 'listStock' });
};

async function updatePorducts() {
    try {
        const stockData = await directus.request(
            readItems('stock', {
                fields: [
                    "history",
                    "device_status", 
                    "status", 
                    "broken_category", 
                    "broken_description",
                    "receive_date",
                    "name_supplier",
                    "po_number",
                    "bill_lading_number",
                    "bill_lading_number_date",
                    "invoice_number",
                    "invoice_number_date",
                    "receipt_number",
                    "receipt_number_date",
                    "bill_number",
                    "due_date",
                    "description",
                    "shelf"
                ],
                filter: {
                    id: { _eq: route.params.id },
                },
                limit: -1
            })
        );

        if (!stockData || stockData.length === 0) {
            console.error('Stock data not found');
            return;
        }

        const currentData = stockData[0];

        if (!Array.isArray(currentData.history)) {
            currentData.history = [];
        }
        
        const updatedData = {
            device_status: formReceiptDetail.value.device_status,
            receive_date: formReceiptDetail.value.receive_date,
            name_supplier: formReceiptDetail.value.name_supplier,
            po_number: formReceiptDetail.value.po_number,
            bill_lading_number: formReceiptDetail.value.bill_lading_number,
            bill_lading_number_date: formReceiptDetail.value.bill_lading_number_date,
            invoice_number: formReceiptDetail.value.invoice_number,
            invoice_number_date: formReceiptDetail.value.invoice_number_date,
            receipt_number: formReceiptDetail.value.receipt_number,
            receipt_number_date: formReceiptDetail.value.receipt_number_date,
            bill_number: formReceiptDetail.value.bill_number,
            due_date: formReceiptDetail.value.due_date,
            shelf: formReceiptDetail.value.shelf,
            description: formReceiptDetail.value.description,
            status: formProductDetail.value.status,
            broken_category: formProductDetail.value.broken_category,
            broken_description: formProductDetail.value.broken_description,
        };

        const changes = {};
        Object.keys(updatedData).forEach((key) => {
            if (updatedData[key] !== currentData[key]) {
                changes[key] = updatedData[key];
            }
        });
        
        if (Object.keys(changes).length === 0) {
            console.log('No changes detected');
            return;
        }

        const timestamp = new Date().toISOString().split('.')[0];
        const user = localStorage.getItem('user_full_name');
        const remarkParts = [];

        if (changes.device_status) {
            remarkParts.push(`เปลี่ยนสถานะสินค้า ${changes.device_status}`);
        }
        if (changes.receive_date) {
            remarkParts.push(`เปลี่ยนวันที่รับสินค้า ${changes.receive_date}`);
        }
        if (changes.name_supplier) {
            remarkParts.push(`เปลี่ยนชื่อผู้จัดจำหน่าย ${changes.name_supplier}`);
        }
        if (changes.po_number) {
            remarkParts.push(`เปลี่ยนเลขที่ใบสั่งซื้อ ${changes.po_number}`);
        }
        if (changes.bill_lading_number) {
            remarkParts.push(`เปลี่ยนเลขที่ใบตราส่ง ${changes.bill_lading_number}`);
        }
        if (changes.bill_lading_number_date) {
            remarkParts.push(`เปลี่ยนวันที่ใบตราส่ง ${changes.bill_lading_number_date}`);
        }
        if (changes.invoice_number) {
            remarkParts.push(`เปลี่ยนเลขที่ใบแจ้งหนี้ ${changes.invoice_number}`);
        }
        if (changes.invoice_number_date) {
            remarkParts.push(`เปลี่ยนวันที่ใบแจ้งหนี้ ${changes.invoice_number_date}`);
        }
        if (changes.receipt_number) {
            remarkParts.push(`เปลี่ยนเลขที่ใบเสร็จ ${changes.receipt_number}`);
        }
        if (changes.receipt_number_date) {
            remarkParts.push(`เปลี่ยนวันที่ใบเสร็จ ${changes.receipt_number_date}`);
        }
        if (changes.bill_number) {
            remarkParts.push(`เปลี่ยนเลขที่บิล ${changes.bill_number}`);
        }
        if (changes.due_date) {
            remarkParts.push(`เปลี่ยนวันที่ครบกำหนด ${changes.due_date}`);
        }
        if (changes.shelf) {
            remarkParts.push(`เปลี่ยนชั้นวาง ${changes.shelf}`);
        }
        if (changes.description) {
            remarkParts.push(`เพิ่มหมายเหตุ ${changes.description}`);
        }

        const remarkText = remarkParts.length > 0 ? `แก้ไขข้อมูล ${remarkParts.join(' ')}` : '';

        currentData.history.push({
            transaction_type: "update",
            timestamp: timestamp,
            remarks: remarkText,
            user: user,
        });

        await directus.request(updateItem("stock", route.params.id, {
            ...changes,
            history: currentData.history,
        }));

        successAlert();
    } catch (error) {
        dangerAlert();
        console.error('Error updating stock:', error);
    }
}

function successAlert() {
    Swal.fire({
        icon: "success",
        title: "อัพเดทสำเร็จ!",
        confirmButtonColor: 'var(--theme-default)',
    });
}

function questionsAlert() {
    return Swal.fire({
        icon: "warning",
        text: 'ยืนยันการลบข้อมูล?',
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        cancelButtonColor: '#efefef',
        confirmButtonText: "ใช่, ลบเลย!",
        confirmButtonColor: 'var(--theme-default)',
    });
}

function deleteAlert() {
    Swal.fire({
        icon: "success",
        title: "ลบข้อมูลสำเร็จ!",
        confirmButtonColor: 'var(--theme-default)',
    });
}

function dangerAlert() {
    Swal.fire({
        icon: "error",
        title: "อัพเดทข้อมูลไม่สำเร็จ!",
        confirmButtonColor: 'var(--theme-default)',
    });
}
</script>